module.exports = __webpack_public_path__ + "img/520x_04_book.3531c1cf.png";